// Mesajlar sayfası için saf yardımcılar (test edilir).

const pad = (n) => String(n).padStart(2, "0");
const sameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

/** Konuşma listesindeki zaman: bugün "14:05", dün "Dün", bu yıl "3 Eki", eski "3.10.2025". */
export const listTimeLabel = (value, now = new Date()) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  if (sameDay(d, now)) return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const y = new Date(now);
  y.setDate(now.getDate() - 1);
  if (sameDay(d, y)) return "Dün";
  if (d.getFullYear() === now.getFullYear()) {
    return d.toLocaleDateString("tr-TR", { day: "numeric", month: "short" });
  }
  return d.toLocaleDateString("tr-TR");
};

/** Mesaj balonundaki saat. */
export const timeOf = (value) => {
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "" : `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** Gün ayıracı: "Bugün", "Dün", "5 Ekim 2026 Pazartesi". */
export const dayLabel = (value, now = new Date()) => {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  if (sameDay(d, now)) return "Bugün";
  const y = new Date(now);
  y.setDate(now.getDate() - 1);
  if (sameDay(d, y)) return "Dün";
  return d.toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric", weekday: "long" });
};

/**
 * Eski sayfalar + son sayfa → tekrarsız, eskiden yeniye sıralı liste ve gün ayıraçları.
 * @returns {Array<{type: "day", key, label} | {type: "message", key, message}>}
 */
export const buildTimeline = (pages, now = new Date()) => {
  const seen = new Set();
  const all = [];
  for (const m of pages.flat()) {
    if (!m || seen.has(String(m._id))) continue;
    seen.add(String(m._id));
    all.push(m);
  }
  all.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  const out = [];
  let lastDay = null;
  for (const m of all) {
    const d = new Date(m.createdAt);
    const dayKey = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
    if (dayKey !== lastDay) {
      out.push({ type: "day", key: `day-${dayKey}`, label: dayLabel(m.createdAt, now) });
      lastDay = dayKey;
    }
    out.push({ type: "message", key: String(m._id), message: m });
  }
  return out;
};

/** Listede önizleme: klinik yazdıysa "Siz: …". */
export const previewLine = (c) =>
  c?.lastMessagePreview ? `${c.lastSenderSide === "clinic" ? "Siz: " : ""}${c.lastMessagePreview}` : "";

export const MAX_MESSAGE_LENGTH = 2000;
